// export constants used throughout the program to avoid working with strings.
export const setDefaultProgramsQuery = "setDefaultProgramsQuery";
export const setProgramsExcludedPrograms = "setProgramsExcludedPrograms";
export const setProgramsQuery = "setProgramsQuery";
export const setProgramsRoFQuery = "setProgramsRoFQuery";
export const setProgramsResults = "setProgramsResults";
export const setProgramsResultsColumns = "setProgramsResultsColumns";
export const setProgramsSummary = "setProgramsSummary";
export const setProgramsColumnTypes = "setProgramsColumnTypes";
export const setProgramsInitStatus = "setProgramsInitStatus";
export const setProgramsGroupBy = "setProgramsGroupBy";
export const setProgramsQueryForAPI = "setProgramsQueryForAPI";
export const setProgramsTimeshift = "setProgramsTimeshift";
export const setProgramsChannels = "setProgramsChannels";
export const setProgramsRoFResults = "setProgramsRoFResults";
export const setProgramsStartdate = "setProgramsStartdate";
export const setProgramsEnddate = "setProgramsEnddate";
export const setProgramsGenres = "setProgramsGenres";
export const setProgramsColumnFieldsOptions = "setProgramsColumnFieldsOptions";
export const setProgramsDisplayColumnFieldsOptions =
  "setProgramsDisplayColumnFieldsOptions";
export const setProgramsAllWithStarSelected = "setProgramsAllWithStarSelected";
export const setProgramsWeekdays = "setProgramsWeekdays";
export const setProgramsRoFResultsLoadDetails =
  "setProgramsRoFResultsLoadDetails";
export const setProgramsSumVisible = "setProgramsSumVisible";
export const setQueryCostData = "setProgramsQueryCostData";
export const setQueryCostLoading = "setProgramsQueryCostLoading";
export const setQueryCostError = "setProgramsQueryCostError";
export const setProgramsMeasures = "setProgramsMeasures";
export const setProgramsQueryBeforeChange = "setProgramsQueryBeforeChange";
export const setProgramsStringForFilterBeforeChange =
  "setProgramsStringForFilterBeforeChange";
export const setHasSetDefaultProgramsQuery = "setHasSetDefaultProgramsQuery";